// Che bot token Mattermost trước khi in ra terminal / log: `***` + 3 ký tự cuối.
//
// Tiền tố cố định `***` (không lặp theo độ dài) để chuỗi in ra không lộ luôn độ dài
// token. Token ≤ 3 ký tự thì chỉ in `***` — lộ 3 ký tự cuối của token ngắn như vậy
// là lộ gần hết token.
const VISIBLE_SUFFIX_LENGTH = 3;

export function maskBotToken(token: string): string {
  const suffix = token.length > VISIBLE_SUFFIX_LENGTH ? token.slice(-VISIBLE_SUFFIX_LENGTH) : "";
  return `***${suffix}`;
}
